module.exports = __webpack_public_path__ + "static/media/2-iveco.c5900aaf.jpg";